<template>
  <button class="clip-btn">
    <div :id="'btnPlayer'+idx"></div>
  </button>
</template>

<script>
  import promokit from '../utils/promokit';
  import {mapState} from 'vuex';

  export default {
    name: "ClipBtn",
    data() {
      return {
        sec:null,
      };
    },
    props:['idx', 'isView'],
    computed: {
      ...mapState([
        'staticPath'
      ])
    },
    created(){
    },
    methods:{

    },
    mounted(){
      this.sec = promokit.sequenceplayer({
        el: `#btnPlayer${this.idx}`,
        path:`${this.staticPath}/img/sequence_play_btn`,
        prefix:"btn_play_",
        frame:179,
        loop:false,
        preload:true
      });

      this.sec.on('canplay', ()=>{
      })

      this.sec.on('end', ()=> {
          this.sec.seek(90)
          this.sec.play();
      });
    },
    watch:{
      'isView': function(val){
        if(val){
          this.sec.play()
        }else{
          this.sec.stop()
        }
      }
    }
  };
</script>

<style lang="scss">
  .clip-btn{
    @include position($position:absolute, $top:50%, $left:50%);
    //@include bg($bg: '../assets/img/clip_btn.png');
    @include hide-text;
    width:278px;
    height:278px;
    border-radius: 50%;
    z-index: 11;
    cursor: pointer;
    /*
    &:after{
      @include position($position:absolute, $top:0, $left:0, $width:100%, $height:100%);
      @include bg($bg: '../assets/img/clip_btn.png');
      background-position-y: -278px;
      content: '';
      opacity:0;
      transition: 0.3s;
    }

    &:hover{
        opacity: 1;
        transition: 0.3s;
    }
*/

  }
</style>
